import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
const rings = [
  {
    title: "Side-Stone Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/sidestone.png',
    Path: "/ringsettings",
  },
  {
    title: "Pave Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/pave.png',
    Path: "/ringsettings",
  },
  {
    title: "Bezel Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/bezel.png',
    Path: "/ringsettings",
  },
  {
    title: "Eternity Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/eternity.png',
    Path: "/ringsettings",
  },
  {
    title: "Curved Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/curved.png',
    Path: "/ringsettings",
  },
  {
    title: "Anniversary Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/aniversary.png',
    Path: "/ringsettings",
  },
  {
    title: "Halo Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/halo.png',
    Path: "/ringsettings",
  },
  {
    title: "Solitaire Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/solitaire.png',
    Path: "/ringsettings",
  },
  {
    title: "Vintage Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/vintage.png',
    Path: "/ringsettings",
  },
  {
    title: "Channel Set Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/channel-set.png',
    Path: "/ringsettings",
  },
  {
    title: "Stackable Rings",
    imgUrl: ImageUrl+'theme/london/ring-style/stackable.png',
    Path: "/ringsettings",
  },
];

function BestSeller() {
  var settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    arrow: true,
    centerMode: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
            centerPadding: "30px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="Lt_bestSeller_section">
        <Container fluid>
          <Row className="m-0 w-100">
            <Col>
              <div className="Lt_title_text">
                <h2> Meet Our Best Sellers </h2>
              </div>
            </Col>

            <Col>
              <div className="Lt_bestSeller_slider">
                <Slider {...settings}>
                  {rings.map((data) => (
                    <div className="Lt_BestSeller">
                      <LazyLoadImage src={data.imgUrl} alt="banners" />
                      <Link to={data.Path}>{data.title} </Link>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default BestSeller;
